import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { get } from 'lodash';
/**
 * Internal dependencies
 */

import { placeholderWhiteBackground as placeholder } from './placeholder';
/**
 * Use `ProductImage` to display a product's or variation's featured image.
 * If no image can be found, a placeholder matching the front-end image
 * placeholder will be displayed.
 *
 * @return { object } -
 */

var ProductImage = function ProductImage(_ref) {
  var product = _ref.product,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["product", "alt", "width", "height", "className"]);

  // The first returned image from the API is the featured/product image.
  var productImage = get(product, ['images', 0]) || get(product, ['image']);
  var src = productImage && productImage.src || false;
  var altText = alt || productImage && productImage.alt || '';
  var classes = classnames('woocommerce-product-image', className, {
    'is-placeholder': !src
  });
  return createElement("img", _extends({
    className: classes,
    src: src || placeholder,
    width: width,
    height: height,
    alt: altText
  }, props));
};

ProductImage.propTypes = {
  /**
   * The width of image to display.
   */
  width: PropTypes.number,

  /**
   * The height of image to display.
   */
  height: PropTypes.number,

  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * Product or variation object. The image to display will be pulled from
   * `product.images` or `variation.image`.
   * See https://woocommerce.github.io/woocommerce-rest-api-docs/#product-properties
   * and https://woocommerce.github.io/woocommerce-rest-api-docs/#product-variation-properties
   */
  product: PropTypes.object,

  /**
   * Text to use as the image alt attribute.
   */
  alt: PropTypes.string
};
ProductImage.defaultProps = {
  width: 60,
  height: 60,
  className: ''
};
export default ProductImage;
//# sourceMappingURL=index.js.map